import { Box } from '@mui/material';
import type { DriverType } from '@repo/supergraph/marketplace/types';
import { CDDriverList } from '../../components/CDDriverList';
import { DriverContent } from '../../components/DriverContent';
import { splitCdApyDrivers } from '../../utils';

type Props = {
  drivers: DriverType[];
  index: number;
};

const wrapperStyles = {
  flex: 1,
  pb: { xs: '12px', md: 0 },
  pr: { xs: 0, md: '1rem' },
};

export const Drivers = ({ drivers, index }: Props) => {
  if (drivers.length === 0) return null;

  const { cdApyDrivers, otherDrivers } = splitCdApyDrivers(drivers);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'stretch',
        width: '100%',
        '& > *': {
          width: { xs: '100%', md: 'auto' },
        },
        '& > * + *': {
          borderTop: { xs: '1px solid', md: 'none' },
          borderLeft: { xs: 'none', md: '1px solid' },
          borderTopColor: { xs: 'neutral.lighter', md: 'transparent' },
          borderLeftColor: { xs: 'transparent', md: 'neutral.lighter' },
          pt: { xs: '1rem', md: 0 },
          pl: { xs: 0, md: '1rem' },
        },
      }}
    >
      {otherDrivers.map(driver => (
        <Box key={`driver-${driver.id}-${index}`} sx={wrapperStyles}>
          <DriverContent driver={driver} variant="stacked" />
        </Box>
      ))}

      {cdApyDrivers.length > 0 && (
        <Box key={`cd-drivers-${index}`} sx={wrapperStyles}>
          <CDDriverList
            drivers={cdApyDrivers}
            variant="simple"
            align={{ xs: 'center', md: 'flex-start' }}
          />
        </Box>
      )}
    </Box>
  );
};
